import {
  APPOINTMENT_CANCEL,
  APPOINTMENT_CLOSE,
  APPOINTMENT_CREATE,
  APPOINTMENT_CONFIRM,
  APPOINTMENT_LIST_CLEAR,
  APPOINTMENT_LIST_FETCH,
  APPOINTMENT_UPDATE, APPOINTMENT_OPEN, APPOINTMENT_SHOW, APPOINTMENT_CURRENT_REP_FETCH
} from '../constants/appointmentTypes';

export function appointmentCancel(params) {
  return {
    type: APPOINTMENT_CANCEL,
    payload: params
  };
}

export function appointmentClose(params) {
  return {
    type: APPOINTMENT_CLOSE,
    payload: params
  };
}

export function appointmentOpen(params) {
  return {
    type: APPOINTMENT_OPEN,
    payload: params
  };
}

export function appointmentCreate(params) {
  return {
    type: APPOINTMENT_CREATE,
    payload: params
  };
}

export function appointmentConfirm(params) {
  return {
    type: APPOINTMENT_CONFIRM,
    payload: params
  };
}

export function appointmentListClear() {
  return {
    type: APPOINTMENT_LIST_CLEAR
  };
}

export function appointmentListFetch(params) {
  return {
    type: APPOINTMENT_LIST_FETCH,
    payload: params
  };
}

export function appointmentUpdate(params) {
  return {
    type: APPOINTMENT_UPDATE,
    payload: params
  };
}

export function appointmentShow(params) {
  return {
    type: APPOINTMENT_SHOW,
    payload: params
  };
}

export function appointmentCurrentRepFetch(params) {
  return {
    type: APPOINTMENT_CURRENT_REP_FETCH,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/appointmentActions.js